<div class="response-modal">
    @if (isSubmitting()) {
        <div class="loading-overlay">
            <span class="loading"></span>
        </div>
    }

    <button
        type="button"
        class="close-btn"
        [disabled]="isSubmitting()"
        (click)="close()"
        aria-label="Close"
    >
        <span class="icon-close"></span>
    </button>

    <div>
        <h4>{{ data.isEditing ? "Edit Response" : "Compose Response" }}</h4>
        @if (!data.isEditing) {
            <p class="modal-description">
                Create a response for this listener. You can use a template,
                customize the message, and add an optional voice response.
            </p>
        }
    </div>

    <div class="response-section">
        <p class="body-1">To:</p>
        <p>{{ data.submitter?.name }}</p>
    </div>

    <div class="response-section">
        <p class="body-1">Submission:</p>
        <p>&ldquo;{{ data.submission.cleanedText }}&rdquo;</p>
    </div>

    <div class="response-section">
        <p class="body-1">Response</p>
        <mat-form-field appearance="outline">
            <mat-label>Choose a response template</mat-label>
            <mat-select [formControl]="badgeControl">
                <mat-option [value]="null">&mdash;</mat-option>
                @for (badge of badgeOptions; track badge.id) {
                    <mat-option [value]="badge.id">
                        {{ badge.name ?? "Response " + badge.displayOrder }}
                    </mat-option>
                }
            </mat-select>
        </mat-form-field>

        @if (showRemoveImage()) {
            <div class="badge-preview">
                <img [src]="selectedBadge()!.imageUrl" alt="Badge" />
                <button type="button" class="text-btn" (click)="removeImage()">
                    Remove Image
                </button>
            </div>
        }

        @if (showResetToTemplate()) {
            <p class="reset-to-template">
                Edited from template &middot;
                <button
                    type="button"
                    class="text-btn"
                    (click)="applyTemplate()"
                >
                    Reset to template
                </button>
            </p>
        }

        <tools-textarea
            placeholder="Select a template or write a custom response."
            [maxLength]="responseTextMaxLength"
            [formControl]="textControl"
        ></tools-textarea>
    </div>

    <div class="response-section">
        <p class="body-1">Link (Optional)</p>
        <tools-input-outline
            label="Link"
            placeholder="Enter a URL"
            [formControl]="linkControl"
        ></tools-input-outline>
    </div>

    <div class="response-section">
        <p class="body-1">Audio File (Optional)</p>
        <p class="caption-4">
            {{ audioFormatLabel }}. {{ maxAudioSizeMb }} MB maximum file size.
        </p>

        @if (audioUploading()) {
            <p class="caption-4">Uploading audio...</p>
        } @else if (audioPreviewUrl()) {
            <div class="audio-preview">
                <audio
                    controls
                    controlsList="nodownload noplaybackrate"
                    [src]="audioPreviewUrl()"
                ></audio>
                <button
                    type="button"
                    mat-icon-button
                    [disabled]="isSubmitting()"
                    aria-label="Remove audio file"
                    (click)="removeAudio()"
                >
                    <span class="icon-trash-outline"></span>
                </button>
            </div>
        }

        <input
            #audioFileInput
            type="file"
            hidden
            [attr.accept]="audioAcceptAttr"
            (change)="onAudioFileSelected($event)"
        />
        <tools-button
            [variant]="ButtonVariant.OUTLINE"
            [isDisabled]="isSubmitting() || audioUploading()"
            (onClick)="openAudioFileInput()"
        >
            Replace Audio File
        </tools-button>
    </div>

    <div class="actions">
        <tools-button
            [variant]="ButtonVariant.OUTLINE"
            [isDisabled]="isSubmitting()"
            (onClick)="close()"
        >
            Cancel
        </tools-button>
        <tools-button [isDisabled]="!canSubmit()" (onClick)="submit()">
            {{ data.isEditing ? "Update Response" : "Post Response" }}
        </tools-button>
    </div>
</div>
